export default "__VITE_ASSET__CpoHJsoG__"